<template>
  <div class="dark-color-bg">
    <div class="bandeau" :style="{
      backgroundImage: 'url(' + require('@/assets/images/bandeau.png') + ')',
    }"></div>
    <div class="container min-h-70v">
      <div class="row h-100 ">
        <div class="col-30 column-center logo-container mt-minus-7vh h-70v">
          <img :src="ecloreLogoWhite" class="ecloreLogo" />
          <img :src="worldImg" class="worldLogo" />
        </div>
        <div class="col-60 pl-5per mt-20px">
          <div class="mobile-pl-pr">
            <h1>
              Bienvenue sur le calculateur<br />
              carbone d’Éclore fonds <br />environnement Trois-Rivières!
            </h1>
            <AccordeonBox :headerText="headerText" :bodyText="bodyText" bgColor="#CCEAED"></AccordeonBox>
            <h2 class="thx mt-50px">
              Merci de faire ce geste et d’encourager cette initiative locale!
            </h2>
            <div class="mt-50px">
              <router-link class="btn-primary btn-responsive" to="/qui-etes-vous">Calculer son empreinte carbone</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import worldImg from "../assets/images/world.png";
import AccordeonBox from "@/components/AccordeonBox";
import ecloreLogoWhite from "../assets/images/eclore_logo_white.png";
export default {
  data() {
    return {
      worldImg,
      ecloreLogoWhite,
      headerText:'Présentation',
      bodyText:'Il s’agit d’un outil simple pour vous aider à estimer vos émissions de gaz à effet de serre. En plus de vous sensibiliser à votre empreinte carbone, vous aurez la possibilité à la fin du parcours de faire un don qui permettra l’achat de crédits carbone certifiés VCS auprès de notre fournisseur. Une partie des profits de la vente de ces crédits sera remis à Éclore pour financer des projets en développement durable sur le territoire de la Ville de Trois-Rivières.'
    };
  },
  components:{
    AccordeonBox
  }
};
</script>
<style scoped>
.btn-primary {
  display:inline-block !important;
}
.bandeau {
  height: 30vh;
  width: 100%;
  background-position: top;
  background-size: cover;
}

.ecloreLogo {
  max-width: 100%;
  max-height: 35%;
}

.worldLogo {
  max-width: 100%;
  max-height: 65%;
}

.mt-minus-7vh {
  margin-top: -10vh;
}

.min-h-70v {
  min-height: 70vh;
  padding-bottom:30px;
  box-sizing:border-box;
}
.h-70v{
  height:70vh;
}
@media (max-width: 956px) {
  .col-30 {
    width: 45%;
  }

  .col-60 {
    width: 48%;
    margin-right:2%;
  }
}

@media (max-width: 660px) {
  .mobile-pl-pr{
    padding-left: 20px;
    padding-right: 20px;
  }
  .ecloreLogo{
    max-width:50%;
  }
  .worldLogo {
    max-width:60%;
  }
  .h-70v {
    height: calc(100% + 40px);
    padding-bottom: 50px;
  }

  .col-30 {
    width: 100%;
  }

  .col-60 {
    width: 100%;
  }
  .btn-responsive{
    display:block;
    width:100%;
    text-align: center;
    box-sizing: border-box;
  }
}
</style>
